/**
 * RecoveryTrac.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchOperator } from './searchOperator';
import { SearchFilterOperationOfActivityLogSearchV3ResponseValue } from './searchFilterOperationOfActivityLogSearchV3ResponseValue';


/**
 * Logical Leaf terminated operation of a <see cref=\"!:SearchFilter\" />  that handles a WHERE filter of the data, based on a   string SearchFilterOperation&lt;T&gt;.Key, SearchOperator SearchFilterOperation&lt;T&gt;.Operator, and compared object? SearchFilterOperation&lt;T&gt;.Value
 */
export interface SearchFilterOperationOfTimeRecordTagDefinitionSearchV3Response { 
    /**
     * Field to filter on
     */
    key: SearchFilterOperationOfTimeRecordTagDefinitionSearchV3Response.KeyEnum;
    /**
     * Operation to use for the filter function
     */
    operator: SearchOperator;
    value: SearchFilterOperationOfActivityLogSearchV3ResponseValue | null;
}
export namespace SearchFilterOperationOfTimeRecordTagDefinitionSearchV3Response {
    export const KeyEnum = {
        Color: 'Color',
        CreatedBy: 'CreatedBy',
        CreatedDate: 'CreatedDate',
        Id: 'Id',
        Label: 'Label',
        SystemKey: 'SystemKey',
        Type: 'Type'
    } as const;
    export type KeyEnum = typeof KeyEnum[keyof typeof KeyEnum];
}


